import React from 'react';
import { performRecovery, gentleReload, getRecoveryCount } from '../../utils/appRecovery';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        console.error('[QC ErrorBoundary] Caught error:', error, info);
    }

    render() {
        if (!this.state.hasError) return this.props.children;
        const recoveries = getRecoveryCount();
        const isPersistent = recoveries >= 2;
        return (
            <div style={styles.overlay}>
                <div style={styles.card}>
                    <div style={styles.iconWrap}>
                        <svg width="40" height="40" viewBox="0 0 24 24" fill="none"
                             stroke="#4DB6AC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="10"/>
                            <line x1="12" y1="8" x2="12" y2="12"/>
                            <line x1="12" y1="16" x2="12.01" y2="16"/>
                        </svg>
                    </div>
                    <h1 style={styles.title}>Une erreur est survenue</h1>
                    <p style={styles.subtitle}>
                        {isPersistent
                            ? "L’application rencontre des problèmes persistants. Essayez de vider le cache de votre navigateur."
                            : "L’application a rencontré un problème. Cela peut être dû à des données corrompues ou à un espace de stockage insuffisant."}
                    </p>
                    {this.state.error && (
                        <details style={styles.details}>
                            <summary style={styles.summary}>Détails techniques</summary>
                            <code style={styles.code}>{this.state.error.toString()}</code>
                        </details>
                    )}
                    <div style={styles.btnRow}>
                        {!isPersistent && (
                            <button style={styles.btnSecondary} onClick={gentleReload}>
                                Recharger simplement
                            </button>
                        )}
                        <button style={styles.btnPrimary} onClick={performRecovery}>
                            {recoveries >= 1 ? 'Réinitialisation complète' : 'Vider le cache et recharger'}
                        </button>
                    </div>
                    {isPersistent && (
                        <p style={styles.hint}>Si le problème persiste, contactez le support QuickCom.</p>
                    )}
                </div>
            </div>
        );
    }
}

const styles = {
    overlay: { position:'fixed', inset:0, display:'flex', alignItems:'center', justifyContent:'center', backgroundColor:'#f8fafc', fontFamily:'-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif', padding:'16px', zIndex:99999 },
    card: { background:'#ffffff', borderRadius:'16px', boxShadow:'0 4px 24px rgba(0,0,0,0.10)', padding:'36px 32px', maxWidth:'420px', width:'100%', textAlign:'center' },
    iconWrap: { display:'flex', alignItems:'center', justifyContent:'center', width:'64px', height:'64px', backgroundColor:'#e6f7f6', borderRadius:'50%', margin:'0 auto 20px' },
    title: { fontSize:'20px', fontWeight:'700', color:'#1e293b', margin:'0 0 10px' },
    subtitle: { fontSize:'14px', color:'#64748b', lineHeight:'1.6', margin:'0 0 20px' },
    details: { textAlign:'left', background:'#f1f5f9', borderRadius:'8px', padding:'12px', marginBottom:'20px', cursor:'pointer' },
    summary: { fontSize:'12px', color:'#94a3b8', fontWeight:'600', userSelect:'none' },
    code: { display:'block', fontSize:'11px', color:'#ef4444', marginTop:'8px', wordBreak:'break-all', whiteSpace:'pre-wrap' },
    btnRow: { display:'flex', flexDirection:'column', gap:'10px' },
    btnPrimary: { background:'#4DB6AC', color:'#ffffff', border:'none', borderRadius:'8px', padding:'12px 20px', fontSize:'14px', fontWeight:'600', cursor:'pointer' },
    btnSecondary: { background:'#f1f5f9', color:'#475569', border:'1px solid #e2e8f0', borderRadius:'8px', padding:'12px 20px', fontSize:'14px', fontWeight:'600', cursor:'pointer' },
    hint: { marginTop:'16px', fontSize:'12px', color:'#94a3b8' },
};

export default ErrorBoundary;
